import React from "react"
import * as styles from "./MenuGroup.module.css"
import { Link } from "gatsby"
import { HeaderTypes } from "../../Header"

export type ItemType = {
  slug: string
  name: string
  title?: string
  type?: string
}

type MenuGroupProps = {
  page: HeaderTypes
  name: string
  items: Array<ItemType>
}

export const MenuGroup = ({ page, name, items }: MenuGroupProps) => {
  return (
    <div className={styles.menuColumn}>
      <h4>{name}</h4>
      <ul className={styles.menuItems}>
        {items.map(x => {
          return (
            <Link
              key={x.name}
              className={styles.item}
              to={`/${page}/${x.slug}/`}
            >
              <li>{x.name}</li>
            </Link>
          )
        })}
      </ul>
    </div>
  )
}
